/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1MonthlyFrequencyConfig } from '../models/V1MonthlyFrequencyConfig';
import { V1WeeklyFrequencyConfig } from '../models/V1WeeklyFrequencyConfig';
import { HttpFile } from '../http/http';

/**
* FrequencyConfig carries recurrence configuration for a Schedule. Exactly one arm of `variant` must be set and the populated arm must match Schedule.frequency. `time_of_day` applies to both frequencies.
*/
export class V1FrequencyConfig {
    /**
    * Time of day in 24-hour ISO 8601 HH:MM:SS format, e.g. \"09:00:00\". Required for both frequencies.
    */
    'timeOfDay': string;
    'weekly'?: V1WeeklyFrequencyConfig;
    'monthly'?: V1MonthlyFrequencyConfig;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "timeOfDay",
            "baseName": "time_of_day",
            "type": "string",
            "format": ""
        },
        {
            "name": "weekly",
            "baseName": "weekly",
            "type": "V1WeeklyFrequencyConfig",
            "format": ""
        },
        {
            "name": "monthly",
            "baseName": "monthly",
            "type": "V1MonthlyFrequencyConfig",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1FrequencyConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

